const translationStrings = {
  blog: {
    by: Drupal.t('von'),
    loadMore: Drupal.t('Mehr laden'),
    readingTime: Drupal.t('Min. Lesedauer'),
  },
  loading: {
    title: Drupal.t('Computer sagt NEIN!'),
    description: Drupal.t(
      'Unsere Webseite unterstützt den Internet Explorer nicht länger. Bitte verwenden Sie einen modernen Browser.',
    ),
  },
  mainMenu: {
    menu: Drupal.t('Menü'),
    overview: Drupal.t('Übersicht'),
    toContact: Drupal.t('Kontakt'),
    close: Drupal.t('Schließen'),
  },
  brandy: {
    name: 'Brandy',
    headerTitle: Drupal.t('Brandy Brandsync'),
    headerSubtitle: Drupal.t('KI-Markenexpertin der trio-group'),
    popupCta: Drupal.t(
      'Jetzt kostenlose Markenanalyse mit brandsync® starten!',
    ),
    greeting: Drupal.t(
      'Hallo, ich bin Brandy, die KI-Markenexpertin der trio-group. Gemeinsam analysieren und erkunden wir Ihre Marke im Vergleich zum Wettbewerb.',
    ),
    chatGreeting: Drupal.t(
      'Wollen Sie wissen, welche emotionalen Treiber Ihre Marke auslöst? Dann legen wir gemeinsam mit unserer brandsync-Methode los uns starten die Wettbewerbsanalyse. Ich freue mich auf unsere Zusammenarbeit, Brandy.',
    ),
    greetingQuestion: '',
    popupGreeting: Drupal.t('Wir können es gleich jetzt ausprobieren!'),
    suggestionStartAnalysis: Drupal.t(
      'Markenanalyse und Wettbewerbsvergleich starten',
    ),
    suggestionBenefits: Drupal.t('Welche Vorteile habe ich durch brandsync?'),
    suggestionBackground: Drupal.t(
      'Erkläre mir mehr über die Hintergründe von brandsync',
    ),
    suggestionLearnMore: Drupal.t('Ich möchte mehr über brandsync® erfahren.'),
    suggestionGenerateBrandMap: Drupal.t(
      'Ja, bitte generiere mir die Brand Map.',
    ),
    inputPlaceholder: Drupal.t('Schreiben Sie mit Brandy...'),
    errorGeneric: Drupal.t(
      'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    ),
    errorTimeout: Drupal.t(
      'Die Anfrage hat zu lange gedauert. Bitte versuche es erneut.',
    ),
    errorRateLimited: Drupal.t(
      'Brandy ist gerade sehr gefragt. Bitte einen Moment Pause einlegen und es dann erneut versuchen.',
    ),
    cooldownPlaceholder: Drupal.t('Bitte @seconds s warten…'),
    loading: Drupal.t('Brandy denkt nach...'),
    pdfDownloadLabel: Drupal.t('Brand Map herunterladen'),
    newMessage: Drupal.t('Neue Nachricht'),
    retryButton: Drupal.t('Erneut versuchen'),
    playfulGreeting: Drupal.t(
      'Wollen Sie Ihre Marke in Echtzeit analysieren? Dann lassen Sie uns starten.',
    ),
  },
  // Overrides for Bonnie; missing keys fall back to brandy.
  bonnie: {
    name: 'Bonnie',
    headerTitle: Drupal.t('Bonnie'),
    headerSubtitle: Drupal.t('Transformations-Expertin Hybride Organisation'),
    popupCta: Drupal.t(
      'Jetzt mit Bonnie über die Hybride Organisation sprechen!',
    ),
    greeting: Drupal.t(
      'Hallo, ich bin Bonnie, die digitale Kollegin der trio-group. Ich zeige Ihnen, wie Menschen und KI-Kollegen in einer Hybriden Organisation erfolgreich zusammenarbeiten.',
    ),
    chatGreeting: Drupal.t(
      'Wollen Sie wissen, welche Aufgaben in Ihrem Team KI-Kollegen übernehmen können? Fragen Sie mich einfach. Ihre Bonnie.',
    ),
    suggestionStartAnalysis: Drupal.t(
      'Ich habe auf der Website etwas Interessantes gelesen und habe eine konkrete Rückfrage.',
    ),
    suggestionBenefits: Drupal.t(
      'Berate mich bitte zu den Bausteinen - wo würden wir beginnen?',
    ),
    suggestionBackground: Drupal.t(
      'Starte ein freies Gespräch und lass uns reden.',
    ),
    // Empty disables the Brand Map follow-up chip.
    suggestionGenerateBrandMap: '',
    inputPlaceholder: Drupal.t('Schreiben Sie mit Bonnie...'),
    errorRateLimited: Drupal.t(
      'Bonnie ist gerade sehr gefragt. Bitte einen Moment Pause einlegen und es dann erneut versuchen.',
    ),
    loading: Drupal.t('Bonnie denkt nach...'),
    pdfDownloadLabel: Drupal.t('PDF herunterladen'),
    playfulGreeting: Drupal.t(
      'Wollen Sie wissen, wie viel Zeit KI-Kollegen Ihrem Team sparen? Dann lassen Sie uns starten.',
    ),
  },
};

export default translationStrings;
